// This constant page is only for auth related constants.
export const PASSWORD_LENGTH = 8;

// accept at least a capital letter, small letter, a number and a special character as optional
export const PASSWORD_REGEX = new RegExp('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,100}$');
export const EMAIL_REGEX = new RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$');